import request from "@/utils/request";
import Setting from "@/utils/setting";

// ============ 管理员登录相关 ============
export function adminLogin(data) {
  return request({
    url: Setting.api + "/adminLogin",
    method: "post",
    data,
  });
}

// 退出登录
export function logout() {
  return request({
    url: Setting.api + "/adminLogout",
    method: "post"
  });
}

// ============ 密码验证相关 ============
export function getOperationVerifyConfig(params) {
  return request({
    url: Setting.api + "/getOperationVerifyConfig",
    params,
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

// ============ 菜单管理相关 ============
export function getMenuTree() {
  return request({
    url: Setting.api + "/getMenuTree",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function getUserMenus() {
  return request({
    url: Setting.api + "/getUserMenus",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function getMenuList(data) {
  return request({
    url: Setting.api + "/getMenuList",
    method: "post",
    data,
  });
}

export function createMenu(data) {
  return request({
    url: Setting.api + "/createMenu",
    method: "post",
    data,
  });
}

export function editMenu(data) {
  return request({
    url: Setting.api + "/editMenu",
    method: "post",
    data,
  });
}

export function deleteMenu(data) {
  return request({
    url: Setting.api + "/deleteMenu",
    method: "post",
    data,
  });
}

// ============ 管理员角色管理 ============
export function assignMenuPermissions(data) {
  return request({
    url:  Setting.api + '/assignMenuPermissions',
    method: 'post',
    data
  });
}

export function getRoleMenuPermissions(params) {
  return request({
    url: Setting.api + "/getRoleMenuPermissions",
    params,
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function getMenuPermissionTree() {
  return request({
    url: Setting.api + "/getMenuPermissionTree",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function getAdminRoleList() {
  return request({
    url: Setting.api + "/getAdminRoleList",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function createAdminRole(data) {
  return request({
    url: Setting.api + "/createAdminRole",
    method: "post",
    data,
  });
}

export function editAdminRole(data) {
  return request({
    url: Setting.api + "/editAdminRole",
    method: "post",
    data,
  });
}

export function deleteAdminRole(data) {
  return request({
    url: Setting.api + "/deleteAdminRole",
    method: "post",
    data,
  });
}

// ============ 管理员用户管理 ============
export function getAdminUserList(data) {
  return request({
    url: Setting.api + "/getAdminUserList",
    method: "post",
    data,
    self: {
      hiddenMsg: true,
    },
  });
}

export function changeAdminUserStatus(data) {
  return request({
    url: Setting.api + "/changeAdminUserStatus",
    method: "POST",
    data,
  });
}

export function createAdminUser(data) {
  return request({
    url: Setting.api + "/createAdminUser",
    method: "post",
    data,
  });
}

export function editAdminUser(data) {
  return request({
    url: Setting.api + "/editAdminUser",
    method: "post",
    data,
  });
}
export function unlockAdminUser(data) {
  return request({
    url: Setting.api + "/unlockAdminUser",
    method: "POST",
    data,
  });
}

export function deleteAdminUser(data) {
  return request({
    url: Setting.api + "/deleteAdminUser",
    method: "post",
    data,
  });
}

// ============ 密码管理 ============
export function adminChangePassword(data) {
  return request({
    url: Setting.api + "/adminChangePassword",
    method: "POST",
    data,
  });
}

export function resetAdminPassword(data) {
  return request({
    url: Setting.api + "/resetAdminPassword",
    method: "POST",
    data,
  });
}

// ============ 其他接口 ============


export function getAdminLoginLogs() {
  return request({
    url: Setting.api + "/getAdminLoginLogs",
    method: "GET",
    
  });
}


export function getAdminUserProfile() {
  return request({
    url: Setting.api + "/getAdminUserProfile",
    method: "GET",
   
  });
}

export function updateAdminUserProfile(data) {
  return request({
    url: Setting.api + "/updateAdminUserProfile",
    method: "POST",
    data,
  });
}
// 用户注册
export function registerApi(data) {
  return request({
    url: Setting.api + "/register",
    method: "POST",
    data,
  });
}

// 用户登录
export function uloginApi(data) {
  return request({
    url: Setting.api + "/ulogin",
    method: "POST",
    data,
  });
}

// 客户端登录
export function cloginApi(data) {
  return request({
    url: Setting.api + "/clogin",
    method: "POST",
    data,
  });
}

// 获取验证码
export function getCaptcha(params) {
  return request({
    url: Setting.api + "/captcha",
    method: "get",
    params,
    self: {
      hiddenMsg: true,
    },
  });
}

/* -------------------羊类目---------------------- */
export function createTypeSheep(data) {
  return request({
    url: Setting.api + "/createTypeSheep",
    method: "post",
    data,
  });
}

export function editTypeSheep(data) {
  return request({
    url: Setting.api + "/editTypeSheep",
    method: "post",
    data,
  });
}

export function getTypeSheepList() {
  return request({
    url: Setting.api + "/getTypeSheepList",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function deleteTypeSheep(data) {
  return request({
    url: Setting.api + "/deleteTypeSheep",
    method: "post",
    data,
  });
}

/* -------------------重量等级配置---------------------- */
export function createWeightLevel(data) {
  return request({
    url: Setting.api + "/createWeightLevel",
    method: "post",
    data,
  });
}

export function editWeightLevel(data) {
  return request({
    url: Setting.api + "/editWeightLevel",
    method: "post",
    data,
  });
}

export function getWeightLevelList() {
  return request({
    url: Setting.api + "/getWeightLevelList",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function deleteWeightLevel(data) {
  return request({
    url: Setting.api + "/deleteWeightLevel",
    method: "post",
    data,
  });
}

/* -------------------地区---------------------- */
export function createZone(data) {
  return request({
    url: Setting.api + "/createZone",
    method: "post",
    data,
  });
}

export function editZone(data) {
  return request({
    url: Setting.api + "/editZone",
    method: "post",
    data,
  });
}

export function getZoneList() {
  return request({
    url: Setting.api + "/getZoneList",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function deleteZone(data) {
  return request({
    url: Setting.api + "/deleteZone",
    method: "post",
    data,
  });
}

/* -------------------角色---------------------- */
export function createRole(data) {
  return request({
    url: Setting.api + "/createRole",
    method: "post",
    data,
  });
}

export function editRole(data) {
  return request({
    url: Setting.api + "/editRole",
    method: "post",
    data,
  });
}

export function getRoleList() {
  return request({
    url: Setting.api + "/getRoleList",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function deleteRole(data) {
  return request({
    url: Setting.api + "/deleteRole",
    method: "post",
    data,
  });
}

/* -------------------权限----------------------- */
export function createPermission(data) {
  return request({
    url: Setting.api + "/createPermission",
    method: "post",
    data,
  });
}

export function editPermission(data) {
  return request({
    url: Setting.api + "/editPermission",
    method: "post",
    data,
  });
}

export function getPermissionList() {
  return request({
    url: Setting.api + "/getPermissionList",
    method: "get",
    self: {
      hiddenMsg: true,
    },
  });
}

export function deletePermission(data) {
  return request({
    url: Setting.api + "/deletePermission",
    method: "post",
    data,
  });
}

/* ------------------用户管理---------------------- */
export function createUser(data) {
  return request({
    url: Setting.api + "/createUser",
    method: "post",
    data,
  });
}

export function getUserList(data) {
  return request({
    url: Setting.api + "/getUserList",
    method: "post",
    data,
    self: {
      hiddenMsg: true,
    },
  });
}

export function editUser(data) {
  return request({
    url: Setting.api + "/editUser",
    method: "post",
    data,
    self: {
      hiddenMsg: false,
    },
  });
}

export function deleteUser(data) {
  return request({
    url: Setting.api + "/deleteUser",
    method: "post",
    data,
  });
}

export function disableUser(data) {
  return request({
    url: Setting.api + "/disableUser",
    method: "PATCH",
    data,
  });
}

export function enableUser(data) {
  return request({
    url: Setting.api + "/enableUser",
    method: "PATCH",
    data,
  });
}
export function updateMemberExpireDate(data) {
  return request({
    url: Setting.api + "/updateMemberExpireDate",
    method: "post",
    data,
    self: {
      hiddenMsg: false,
    },
  });
}


/* ----------------其他接口（保持原样）--------------------- */
export function refreshTokenApi(data) {
  return request({
    url: Setting.api + "/refreshToken",
    method: "POST",
    data,
  });
}

export function getDeptTree() {
  return request({
    url: Setting.api + "/dept/tree",
    method: "get",
  });
}

export function changeStatus(data) {
  return request({
    url: Setting.api + "/users/changeStatus",
    method: "POST",
    data,
  });
}

export function getMenu() {
  return request({
    url: Setting.api + "/menus/getMenu",
    method: "get",
  });
}

export function addUser(data) {
  return request({
    url: Setting.api + "/users/register",
    method: "POST",
    data,
  });
}

// 供应商登录
export function supplierLogin(data) {
  return request({
    url: Setting.api + '/login',
    method: 'post',
    data,
    self: { hiddenMsg: true }
  })
}

// 获取供应商授权的批次列表
export function getSupplierBatches(params  ) {
  return request({
    url: Setting.api + '/getSupplierBatches',
    method: 'get',
    params  
  })
}

// 更新养殖户备注
export function updateFarmerRemark(data) {
  return request({
    url: Setting.api + '/updateFarmerRemark',
    method: 'post',
    data
  })
}

// 获取某天的配料数据
export function getSupplierDailyFeeds(params) {
  return request({
     url: Setting.api + '/getSupplierDailyFeeds',
    method: 'get',
    params
  })
}
export function getBatchAllFeeds(params) {
  return request({
     url: Setting.api + '/getBatchAllFeeds',
    method: 'get',
    params
  })
}


// 保存配料
export function saveSupplierDailyFeed(data) {
  return request({
     url: Setting.api + '/saveDailyFeed',
    method: 'post',
    data
  })
}
export function updateBatchCurrentSheepCount(data) {
  return request({
     url: Setting.api + '/updateBatchCurrentSheepCount',
    method: 'post',
    data
  })
}


// 批量保存配料
export function batchSaveSupplierDailyFeeds(data) {
  return request({
    url: Setting.api + '/batchSaveDailyFeeds',
    method: 'post',
    data
  })
}

/**
 * 获取养殖户授权详情（供应商）
 */
export function getFarmerAuthDetail(params) {
  return request({
    url: Setting.api + '/getFarmerAuthDetail',
    method: 'get',
    params
  })
}

/**
 * 供应商解除授权
 */
export function revokeAuthBySupplier(data) {
  return request({
    url: Setting.api + '/revokeAuthBySupplier',
    method: 'post',
    data
  })
}

// ============ 操作密码管理 ============

/**
 * 检查是否已设置操作密码
 */
export function checkOperationPassword() {
  return request({
   url: Setting.api + '/checkOperationPassword',
    method: 'GET',
  });
}

/**
 * 设置/修改操作密码
 */
export function setOperationPassword(params) {
  return request({
   url: Setting.api + '/setOperationPassword',
    method: 'POST',
    data: params,
  });
}

/**
 * 发送操作验证码（复用已有接口）
 * 注意：这个接口已存在于 auth.controller.js 的 getCodes 中
 * 但为了区分，建议新增一个专门给管理员用的
 */
export function sendAdminVerifyCode(params) {
  return request({
   url: Setting.api + '/sendAdminVerifyCode',
    method: 'POST',
    data: params,
  });
}

/**
 * 获取供应商授权码
 */
export function getSupplierAuthCode() {
  return request({
    url: Setting.api + '/getSupplierAuthCode',
    method: 'get'
  })
}

/**
 * 设置供应商授权码
 */
export function setSupplierAuthCode(data) {
  return request({
    url: Setting.api + '/setSupplierAuthCode',
    method: 'post',
    data
  })
}